import React, { useState } from 'react';
import { useSelector } from '@xstate/react';
import { Modal, useModalVariant } from '@chargify/custom-ui-components';
import { PaymentsContainer } from '@chargify/payments-sdk';

import { Content } from './components';

import { useServices } from '../../hooks';
import { modalsSelectors } from '../../machines';

const PaymentProfile = () => {
  const [closeDisable, setCloseDisable] = useState(false);
  const { modalsService } = useServices();
  const modalVariant = useModalVariant();
  const { isOpen, meta } = useSelector(
    modalsService,
    modalsSelectors.getCreatePaymentProfile
  );

  const closeHandler = (successUpdate?: boolean) => {
    if (!closeDisable || successUpdate)
      modalsService.send({ type: 'CLOSE_MODAL' });
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={closeHandler}
      variant={modalVariant}
      width="100%"
    >
      <PaymentsContainer>
        <Content
          paymentMethod={'creditCard'}
          {...meta}
          displayMode={modalVariant}
          onProcessingUpdate={(isProcessing) => setCloseDisable(isProcessing)}
          onClose={closeHandler}
        />
      </PaymentsContainer>
    </Modal>
  );
};

export default PaymentProfile;
